/* eslint-disable */

// custom_queries.js

import { gql } from 'graphql-tag';

export const getUserByUsernameWithProjects = gql`
  query GetUserByUsernameWithProjects($username: String!) {
    getUserByUsername(username: $username) {
      items {
        id
        username
        email
        isAdmin
        createdAt
        updatedAt
        projects {
          items {
            project {
              id
              name
              path
              metadata
              mapping
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;

export const getUserByUsername = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      email
      isAdmin
      createdAt
      updatedAt
      projects {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
